import {
  TSteelGradeGroup,
} from './select-alloying-elements';

const steelGradeGroup: Record<TSteelGradeGroup, string> = {
  caseHardeningSteel: 'Oceľ na cementáciu',
  nitridingSteel: 'Oceľ na nitridáciu',
  temperingSteel: 'Oceľ na zušľachťovanie',
  bearingSteel: 'Ložisková oceľ',
};

export default {
  placeholder: 'Vybrať skupinu tried ocele',
  steelGradeGroup,
};
